import { createClient } from '@supabase/supabase-js';

// Obtener las variables de entorno, con fallback a valores del window para producción
const getSupabaseUrl = (): string => {
  // Primero intentar desde variables de entorno (build time)
  if (import.meta.env.VITE_PUBLIC_SUPABASE_URL) {
    return import.meta.env.VITE_PUBLIC_SUPABASE_URL;
  }
  
  // Luego intentar desde window (runtime, para producción)
  if (typeof window !== 'undefined' && (window as any).__SUPABASE_URL__) {
    return (window as any).__SUPABASE_URL__;
  }
  
  // Si no hay nada, mostrar error claro
  console.error('❌ VITE_PUBLIC_SUPABASE_URL no está configurada. Por favor, configura las variables de Supabase.');
  return '';
};

const getSupabaseAnonKey = (): string => {
  // Primero intentar desde variables de entorno (build time)
  if (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY) {
    return import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;
  }
  
  // Luego intentar desde window (runtime, para producción)
  if (typeof window !== 'undefined' && (window as any).__SUPABASE_ANON_KEY__) {
    return (window as any).__SUPABASE_ANON_KEY__;
  }
  
  // Si no hay nada, mostrar error claro
  console.error('❌ VITE_PUBLIC_SUPABASE_ANON_KEY no está configurada. Por favor, configura las variables de Supabase.');
  return '';
};

const supabaseUrl = getSupabaseUrl();
const supabaseAnonKey = getSupabaseAnonKey();

// Validar que las credenciales estén configuradas
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ Supabase no está configurado correctamente. Las funciones de base de datos no funcionarán.');
}

export const supabase = supabaseUrl && supabaseAnonKey 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : createClient('', ''); // Cliente vacío como fallback

// Tipos exportados explícitamente como 'type'
export type Game = {
  id: string;
  home_team: string;
  away_team: string;
  home_team_logo?: string;
  away_team_logo?: string;
  date: string;
  time: string;
  location?: string;
  jornada?: number;
  title?: string;
  created_at?: string;
};

export type Result = {
  id: string;
  game_id: string;
  home_team: string;
  away_team: string;
  home_score: number;
  away_score: number;
  status: string;
  created_at?: string;
  updated_at?: string;
};

export type Standing = {
  id: string;
  team_name: string;
  category: string;
  games_played: number;
  wins: number;
  losses: number;
  points_for: number;
  points_against: number;
  points: number;
  position: number;
  created_at?: string;
  updated_at?: string;
};

export type Player = {
  id: string;
  name: string;
  position: string;
  number: number;
  team_id: string;
  image_url?: string;
  created_at?: string;
};

export type News = {
  id: string;
  title: string;
  text: string;
  image?: string;
  category: string;
  author?: string;
  created_at: string;
  video_url?: string;
};

export type Sponsor = {
  id: string;
  name: string;
  logo?: string;
  logo_img?: string;
  website?: string;
  created_at?: string;
};
